import { useEffect, useId, useState } from "react";
import { api } from "@/comn";
import { Icon, Badge } from "@/comn/components";

export const HeaderTodoButton = () => {
    const id = useId();
    const [data, setData] = useState([]);

    useEffect(() => {
        getTodo();
        const intervalId = setInterval(() => {
            getTodo();
        }, 300000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const getTodo = async () => {
        try {
            let base = "",
                path = "";
            base = process.env.REACT_APP_URL_PTLO || "";
            path = "/api/v1/osci/ptl/mypage/todo/main";
            const response = await api.get(base + path);
            setData(response.data.todoList.content);
        } catch (error) {
            // console.log(error);
        }
    };

    /**
     * 상단 할 일 API가 참조 ID까지 결합한 화면 주소에 메인 My task와 동일한 쿼리 파라미터를 추가한다.
     */
    const getTodoDtlUrl = (todo: any) => {
        const scrnDocUrlAddr = todo.scrnDocUrlAddr || "";
        const separator = scrnDocUrlAddr.includes("?") ? "&" : "?";
        const frontDmn = process.env.REACT_APP_API_FRONT_OSCI || "";

        return `${frontDmn}${scrnDocUrlAddr}${separator}menuId=mytodo&ptlTodoPrcdStatCd=${todo.ptlTodoPrcdStatCd}`;
    };

    /**
     * 메인 화면의 My task와 동일한 URL 규칙과 현재 창 이동 방식으로 할 일 상세 화면을 연다.
     */
    const handleMoveTodoDtl = (todo: any) => {
        window.open(getTodoDtlUrl(todo), "_parent");
    };

    const number = data.length || undefined;

    return (
        <div className="group relative">
            <Badge number={number}>
                <button
                    type="button"
                    className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                >
                    <Icon icon="list" />
                </button>
            </Badge>
            {number && (
                <div className="z-[9999] absolute border shadow top-full left-0 w-60 rounded bg-navigation hidden group-hover:block">
                    <div className="p-2 text-lg font-bold">{number}개의 메세지가 있습니다</div>
                    <ul className="divide-y max-h-[480px] overflow-y-auto">
                        {data.map((todo: any, index) => {
                            return (
                                <li
                                    key={id + index}
                                    className="p-2 cursor-pointer hover:bg-background [&_div]:hover:underline"
                                >
                                    <a
                                        href={getTodoDtlUrl(todo)}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            handleMoveTodoDtl(todo);
                                        }}
                                    >
                                        <span className="text-sm text-darkgray">{todo.frstRgsrDtm}</span>
                                        <div className="font-semibold">{todo.todoBsopDvn}</div>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};
